import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion'
import { db } from '../index.js';
import { collection, doc, getDocs } from 'firebase/firestore';

import world from '../assets/world-1.png' 
import worldCastle from '../assets/world-2.png' 
import worldSky from '../assets/world-3.png' 

const Intro = () => {
    const isMobile = window.innerWidth < 1370; //Add the width you want to check for here (now 768px)
    //if the width >= 768px, boxVariants will be empty, resulting in no animation
    //you need to refresh the page, it doesn't work when you resize it!
    const [users, setUsers] = useState([]);
    const usersCollectionRef = collection(db, "users");
    // called whenever page renders
    useEffect (()=> {
        const getUsers = async () => {
            const data = await getDocs(usersCollectionRef);
            setUsers(data.docs.map((doc) => ({ ...doc.data(), id: doc.id }))) 
            console.log(users)
        };

        getUsers();
    }, []);

  return (
    
    <>
    <div className='w-full'>
        <div className='max-w-[1240px] mx-auto'>
            <div className='p-10 sm:p-20 md:my-96'>
                <div className='grid grid-cols-1 lg:grid-cols-2 gap-x-8 content-start'>
                    <motion.div
                    className='z-10'
                         initial={{ x: -300, opacity: 0 }}
                         transition={{ delay: 0.25, duration: 0.5 }}
                         whileInView={{ opacity: 1, x: 0}}
                         viewport={{ once: true }}
                    >
                        <h1 className='text-3xl md:text-5xl font-bold'>The World of EtherFrens</h1> 
                            <p className='text-xl md:text-2xl py-6'>
                                An art focused NFT collection. We plan to create a community by slowly onboarding members. Our art is heavy inspired from a variety of origins ranging from pop to anime and Asian cultures.
                            </p>
                            <p>
                                
                            {/* <button type="button" class="text-white hover:text-white bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm p-2.5 text-center inline-flex items-center mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                                <span class="sr-only">Continue</span>
                            </button> */}
                            </p>
                        <p className='text-xl md:text-2xl py-6'>
                        </p>
                    </motion.div>
                    <motion.div 
                        className='my-8 sm:mt-24 mb-56 sm:mb-56 md:mb-32 md:mt-0 lg:mb-0'
                        initial={isMobile ? {scale:1.0} : {scale:0.75}}
                        transition={ isMobile ?
                            { type: "", stiffness: 0,  damping: 0, delay: 0.0} :
                            { type: "spring", stiffness: 100,  damping: 5, delay: 0.25}     
                        }
                        whileInView={ isMobile ? 
                            { scale: 1.0 } :
                            { scale: 1.5 }}
                        viewport={{ once: true }}
                    >
                        <div class="relative overflow-x-clip">
                            <img className='absolute animate-spin-slow-10' src={world} alt="" />
                            <img className='absolute animate-spin-slow-25' src={worldCastle} alt="" />
                            <img className='absolute animate-spin-slow-30' src={worldSky} alt="" />
                        </div>
                    </motion.div>
                </div>
            </div>    
        </div>
    </div>
    </>
  )
}

export default Intro